/**
Project: Voice Panel (c)
Title: Page Wait Dialog
Description: Component for displaying the page wait dialog box
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import React from "react";
import { connect } from "react-redux";
import { Dialog, Loader } from "@fluentui/react-northstar";

const PageWaitDialog = ({ pageWaitDialogData }) => {
  return (
    <Dialog
      backdrop={true}
      content={
        <>
          <Loader
            size={pageWaitDialogData.spinnerSize}
            label={pageWaitDialogData.labelText}
            labelPosition={pageWaitDialogData.labelPosition}
          />
        </>
      }
      open={pageWaitDialogData.displayStatus}
      className="page-wait-dialog"
    />
  );
};

const mapStateToProps = (state) => ({
  pageWaitDialogData: state.generalStore.pageWaitDialogData,
});

const mapActionToProps = {};

export default connect(mapStateToProps, mapActionToProps)(PageWaitDialog);
